import { render, staticRenderFns } from "./PalierCustomerNewUi.vue?vue&type=template&id=60b2977f&scoped=true&"
import script from "./PalierCustomerNewUi.vue?vue&type=script&lang=js&"
export * from "./PalierCustomerNewUi.vue?vue&type=script&lang=js&"
import style0 from "./PalierCustomerNewUi.vue?vue&type=style&index=0&id=60b2977f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b2977f",
  null
  
)

export default component.exports